module.exports = __webpack_public_path__ + "img/new-nora-logo.d44e37.png";